export default "__VITE_ASSET__CRe9rzIz__"